export interface GalleryItem {
  id: number;
  image: string;
  caption: string;
  tab: 'events' | 'livestock';
  span?: 'tall' | 'wide' | 'normal';
}

export const galleryItems: GalleryItem[] = [
  // ── EVENTS ──────────────────────────────────────────────────────────────────
  {
    id: 101,
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/13619a33-b8cf-4b0c-970f-9fd22d8d30cb_H1.jpg?v=aa0d39412901ace41b4b448ccccd506e',
    caption: 'Hamva Event',
    tab: 'events',
    span: 'normal',
  },
  {
    id: 102,
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/7c45d4e9-bfde-4fde-a55e-2ab6a0ee3365_H2.jpg?v=19eb77a975ae07a946f9b973b6ecaab5',
    caption: 'Hamva Event',
    tab: 'events',
    span: 'tall',
  },
  {
    id: 103,
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/64976f67-0ab3-4600-a418-2e8910e7b72a_H3.jpg?v=5f729a83ac1da0ea3c06397e9ee86b7b',
    caption: 'Hamva Event',
    tab: 'events',
    span: 'normal',
  },
  {
    id: 104,
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/ace01e41-bede-421c-bd54-eba68d24e1c0_H4.jpg?v=70f6bb642e62ad80a23c95680d9e953e',
    caption: 'Hamva Event',
    tab: 'events',
    span: 'normal',
  },
  {
    id: 105,
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/a30bd368-bdc2-459a-8034-1644904caf56_H5.jpg?v=e660ff01fe2fc9168dbf90a985088405',
    caption: 'Hamva Event',
    tab: 'events',
    span: 'tall',
  },
  {
    id: 106,
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/d8adfe19-f448-4f1f-9a93-6491b787c515_H6.jpg?v=652831ec648d947ca1e9cdb525602e29',
    caption: 'Hamva Event',
    tab: 'events',
    span: 'normal',
  },
  {
    id: 107,
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/77ffd88b-7a40-4fbb-bd3f-2d0a3ab48388_H7.jpg?v=702e63b9218db43699618391b2d851c5',
    caption: 'Hamva Event',
    tab: 'events',
    span: 'normal',
  },
  {
    id: 108,
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/8ad30f16-cd0f-4039-b37a-2734b621ccbc_H8.jpg?v=45a73e26448ef403a99af2d093c0b799',
    caption: 'Hamva Event',
    tab: 'events',
    span: 'tall',
  },
  {
    id: 109,
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/63043c50-e7fd-48ea-a069-74e6166d4ac5_H9.jpg?v=43f0f3c7d957ffb46776c2d0f9e1298d',
    caption: 'Hamva Event',
    tab: 'events',
    span: 'normal',
  },
  {
    id: 110,
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/8fcdd22e-6af4-4463-a3ec-564dc23560cc_H10.jpg?v=544c655056ab28e1bd91415f2eb1c2da',
    caption: 'Hamva Event',
    tab: 'events',
    span: 'normal',
  },

  // ── LIVESTOCK ─────────────────────────────────────────────────────────────
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=healthy%20dairy%20cows%20in%20modern%20farm%20stall%20golden%20hour%20cinematic%20photography%20dramatic%20warm%20light%20beautiful%20cattle%20herd%20premium%20farm%20facility&width=600&height=800&seq=g1&orientation=portrait',
    caption: 'Healthy Dairy Herd',
    tab: 'livestock',
    span: 'tall',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Hamva%20veterinary%20pharmaceutical%20products%20lineup%20professional%20dark%20studio%20photography%20premium%20branding%20animal%20health%20product%20range&width=600&height=400&seq=g2&orientation=landscape',
    caption: 'Hamva Product Range',
    tab: 'livestock',
    span: 'normal',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=farmer%20with%20healthy%20buffalo%20cattle%20Pakistan%20farm%20green%20fields%20golden%20morning%20light%20documentary%20photography%20livestock%20agriculture&width=600&height=400&seq=g3&orientation=landscape',
    caption: 'Farmers Trust Hamva',
    tab: 'livestock',
    span: 'normal',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=modern%20livestock%20feed%20manufacturing%20facility%20interior%20industrial%20machinery%20pharmaceutical%20production%20quality%20control%20Pakistan&width=800&height=400&seq=g4&orientation=landscape',
    caption: 'Manufacturing Excellence',
    tab: 'livestock',
    span: 'wide',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=baby%20calf%20newborn%20healthy%20farm%20animal%20cute%20young%20livestock%20beautiful%20golden%20light%20natural%20farm%20environment%20photography&width=600&height=800&seq=g5&orientation=portrait',
    caption: 'Healthy Calves',
    tab: 'livestock',
    span: 'tall',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=poultry%20chicken%20farm%20healthy%20birds%20modern%20facility%20dramatic%20lighting%20top%20view%20professional%20agricultural%20photography&width=600&height=400&seq=g6&orientation=landscape',
    caption: 'Poultry Health Solutions',
    tab: 'livestock',
    span: 'normal',
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=milk%20production%20dairy%20farm%20modern%20milking%20machinery%20equipment%20clean%20facility%20professional%20photography%20dairy%20industry&width=600&height=400&seq=g7&orientation=landscape',
    caption: 'Enhanced Milk Yield',
    tab: 'livestock',
    span: 'normal',
  },
];

export const eventItems = galleryItems.filter((g) => g.tab === 'events');
export const livestockItems = galleryItems.filter((g) => g.tab === 'livestock');
